import { Injectable } from '@angular/core';
import { TutorialConfig, TutorialStep } from '../components/shared/tutorial-popup/tutorial-popup.component';

@Injectable({
  providedIn: 'root'
})
export class TutorialConfigService {

  constructor() { }

  /**
   * Get tutorial configuration for About Us section
   */
  getAboutUsTutorialConfig(companyGuid: string): TutorialConfig {
    return {
      sectionName: 'about-us',
      localStorageKey: `aboutUsTutorialCompleted_${companyGuid}`,
      steps: [
        {
          stepNumber: 1,
          title: 'Add Images for Your Website',
          description: 'Be sure to upload images by clicking on the placeholder in your website preview.',
          gifSrc: 'assets/tutorials/about-us-image-upload.gif',
          gifDuration: 2000, 
          buttonText: 'Continue',
          isLastStep: false
        },
        {
          stepNumber: 2,
          title: 'Edit Your Content at any time',
          description: 'Your content can be edited at anytime by clicking on it within your website preview and adjusting it on the left-hand side.',
          gifSrc: 'assets/tutorials/about-us-content-edit.gif',
          gifDuration: 2000, 
          buttonText: 'Done',
          isLastStep: true
        }
      ]
    };
  }

  /**
   * Get tutorial configuration for Capabilities section
   */
  getCapabilitiesTutorialConfig(companyGuid: string): TutorialConfig {
    return {
      sectionName: 'capabilities',
      localStorageKey: `capabilitiesTutorialCompleted_${companyGuid}`,
      steps: [
        {
          stepNumber: 1,
          title: 'Add Images for Your Website',
          description: 'Be sure to upload images by clicking on the placeholder in your website preview.',
          gifSrc: 'assets/tutorials/capabilities-image-upload.gif',
          gifDuration: 2000,
          buttonText: 'Continue',
          isLastStep: false
        },
        {
          stepNumber: 2,
          title: 'Edit Your Content at any time',
          description: 'Your content can be edited at anytime by clicking on it within your website’s preview and adjusting it on the left-hand side.',
          gifSrc: 'assets/tutorials/capabilities-content-edit.gif',
          gifDuration: 2000,
          buttonText: 'Done',
          isLastStep: true
        }
      ]
    };
  }

  /**
   * Check if tutorial has been completed for a specific section
   */
  isTutorialCompleted(companyGuid: string, sectionName: string): boolean {
    const localStorageKey = `${sectionName}TutorialCompleted_${companyGuid}`;
    return localStorage.getItem(localStorageKey) === 'true';
  }

  /**
   * Mark tutorial as completed for a specific section
   */
  markTutorialCompleted(companyGuid: string, sectionName: string): void {
    const localStorageKey = `${sectionName}TutorialCompleted_${companyGuid}`;
    localStorage.setItem(localStorageKey, 'true');
  }

  
}
